document.addEventListener('DOMContentLoaded', function (event) {
	const loadMore = document.getElementById('tag-load-more');

	if (loadMore) {
		loadMore.addEventListener('click', function (e) {
			e.preventDefault();
			const currentPage = parseInt(loadMore.dataset?.page);

			const get = new URLSearchParams();
			get.set('page', currentPage + 1);
			get.set(
				'lang',
				document.getElementById('current-langauge')?.value ?? 'en'
			);

			const tag = document.getElementById('tag');

			if (tag) get.set('tags', tag.value);

			const xmlhttp = new XMLHttpRequest();

			xmlhttp.onreadystatechange = function () {
				if (xmlhttp.readyState == XMLHttpRequest.DONE) {
					if (xmlhttp.status === 200) {
						// Wordpress header that relays how many pages are in the API query
						const totalPages =
							xmlhttp.getResponseHeader('X-WP-TotalPages');
						const items = JSON.parse(this.response);

						items.forEach((item) => {
							const excerpt = item.excerpt.rendered.replace(
								/<\/?[^>]+(>|$)/g,
								''
							);

							const template = `
                <h4 class="taxonomy__card-title"><a href="${item.link}">${item.title.rendered}</a></h4>
                <p>
                  <strong>${item.publish_date} - ${item.author_display_name} |</strong> ${excerpt};
                </p>

                <div class="taxonomy__details">
                  <div>
                    <a href="${item.category_url}" class="pill">${item.primary_category}</a>
                    <span>${item.readtime}</span>
                  </div>
                  <a href="${item.link}">
                    <svg width="37" height="27" viewBox="0 0 37 27" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
                      <path d="M34.8346 13.5L2.16797 13.5M34.8346 13.5L22.5846 25.75M34.8346 13.5L22.5846 1.25" stroke="#003E52" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </div>
              `;

							const taxonomyCard = document.createElement('div');
							taxonomyCard.classList.add('taxonomy__card');

							taxonomyCard.innerHTML = template;
							document
								.querySelector('.taxonomy__list')
								.append(taxonomyCard);

							// Determine if we should hide the load more button or not
							if (
								parseInt(totalPages) ===
								parseInt(currentPage + 1)
							) {
								loadMore.classList.add('hidden');
							} else {
								loadMore.dataset.page = currentPage + 1;
							}
						});
					}
				}
			};

			xmlhttp.open('GET', '/wp-json/wp/v2/posts?' + get.toString(), true);

			xmlhttp.send();
		});
	}
});
